export const websites = [
  "Amazon",
  "Walmart",
  "Target",
  "Costco",
  "Etsy",
  "Best Buy",
  "Newegg",
  "Macy's",
  "Nordstrom",
  "Zappos",
  "ASOS",
  "Gap",
  "Uniqlo",
  "Michaels",
  "Wayfair",
  "Home Depot",
  "IKEA",
  "Lowe's",
  "Overstock",
  "Sephora",
  "Ulta",
  "Dermstore",
  "Dick's Sporting Goods",
  "REI",
  "Academy Sports + Outdoors",
];
